import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { NotificationTypeDto } from '../../../shared-new/enums/notification-type.enum';


import { MatDataSource } from '../../../shared-new/util/mat-datasource';


export class NotificationTypeListDataSource extends MatDataSource<NotificationTypeDto> {

  public constructor(
    data: NotificationTypeDto[],
    sort: MatSort,
    disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20
  ) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }

  clearFilter(): void {
    this.filter = '';  // Clear the filter value
    this.filteredData = [...this.data];  // Reset the filtered data to the original data
    this._updateChangeSubscription();  // Trigger data refresh
  }

  setFilterPredicate(): void {
    this.filterPredicate = (sale: NotificationTypeDto, filterValue: string) => {
      return 'name,description,notificationGroupName,defaultEmailSubject,defaultEmailBody,defaultSMSText,tagLegend'.split(',').some((key) => {
        return (
          sale[key as keyof NotificationTypeDto] &&
          new RegExp(filterValue.trim().toLowerCase(), 'gi').test(
            sale[key as keyof NotificationTypeDto]
          )
        );
      });
    };
  }
}
